module.exports = __webpack_public_path__ + "files/f9afa3d10bfdeca899c8fc5206d746f5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-3.png
// module id = 502
// module chunks = 76